import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Session } from './session.service';
import { OutboundSsoService } from './outbound-sso.service';
import {
  LeaveLinkAccessDialogComponent,
  LeaveLinkAccessData,
} from '../components/dialogs/leavelinkaccess-dialog.component';
import { TranslationPipe } from '../pipes/translation.pipe';

@Injectable({
  providedIn: 'root',
})
export class LeaveLinkAccessService {
  constructor(
    private session: Session,
    private dialog: MatDialog,
    private outboundSsoService: OutboundSsoService,
    private translationPipe: TranslationPipe
  ) {}

  handleLeaveLinkAccess(): void {
    if (this.session.user?.isTerminated) {
      this.showErrorDialog(
        'You may no longer access LeaveLink due to a change in your employment status. If you believe this message is in error or require further assistance, please contact HR OneStop.'
      );
      return;
    }

    if (this.session.isDelegating()) {
      this.showErrorDialog(
        'LeaveLink access is restricted in Delegate mode. To access LeaveLink, please exit Delegate mode.'
      );
      return;
    }

    const leaveLinkSso = this.session.user?.outboundSSO?.find(
      (sso) => sso.ssoType?.toLowerCase() === 'leavelink'
    );

    if (leaveLinkSso) {    
      this.outboundSsoService.showConfirmationDialog(
        leaveLinkSso.ssoType,
        leaveLinkSso.ssoEndPoint
      );
    } else {
      this.showErrorDialog(
        'You may no longer access LeaveLink due to a change in your employment status. If you believe this message is in error or require further assistance, please contact HR OneStop.'
      );
    }
  }



  private showErrorDialog(message: string): void {
    this.dialog.open(LeaveLinkAccessDialogComponent, {
      data: { message : this.translationPipe.transform(message) } as LeaveLinkAccessData,
    });
  }

}
